import { useEffect } from "react";
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useAuth } from './request/AuthProvider';
import Alert from 'react-bootstrap/Alert';
import { useSearch } from "../search/SearchProvider";
import { useContratos } from "../contratos/ContratosProvider";
import { useToast } from "../notificaciones/ToastProvider";

/**
 * @const validarDatos validaciones del formulario
 */
const validarDatos = Yup.object().shape({
    usuario: Yup.string()
        .required('Campo obligatorio'),
    password: Yup.string()
        .required('Campo obligatorio'),
})
/**
 *
 * @type {{usuario: string, password: string, modulo: string}}
 */
const valorInicial = {
    usuario: '',
    password: '',
    modulo: '',
}
/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Login() {
    const auth = useAuth();
    const { errorApi } = useAuth();
    /**
     * @property cleanData // limpiar contexto de finder
     * @type {undefined}
     */
     const { cleanData } = useSearch();
    /**
     * @property cleanContext //  limpiar contexto de tabla contratos
     * @type {undefined}
     */
        const { cleanContext } = useContratos();
    /**
     * @property cleanToast // limpiar contexto de notíficaciones laterales
     */
    const { cleanToast } = useToast();
    /**
     * Limpiar estados y valores
     */
    useEffect(() => {
        cleanData();
        cleanContext();
        cleanToast();
        sessionStorage.clear();
        localStorage.clear();
        // eslint-disable-next-line
    },[]);

    /**
     * @function onSubmit enviar valores del formulario
     * @param values
     * @param actions
     * @returns {Promise<void>}
     */
    const onSubmit = async (values, actions) => {
       auth.loginAction(values.usuario, values.password);

       if (errorApi.show){
           actions.setSubmitting(false);
       }
    };
    /**
     * Constantes de formik, necesarias para el manejo del formulario
     */
    const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik({
        initialValues: valorInicial,
        validationSchema: validarDatos,
        onSubmit,
    });
    return (
        <>
            <div className="d-flex flex-column flex-root">
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                            <div className="w-lg-500px p-10">
                                <form className="form w-100" onSubmit={handleSubmit} id="kt_sign_in_form" >
                                    <div className="text-center mb-11">
                                        <h1 className="text-dark fw-bolder mb-3">Iniciar sesión</h1>
                                        <div className="text-gray-500 fw-semibold fs-6">Ingresa tus datos</div>
                                    </div>
                                    {
                                    errorApi.show && <Alert variant="danger" >
                                                        <Alert.Heading>¡{errorApi.error}!</Alert.Heading>
                                                        <p>
                                                            {errorApi.message}
                                                        </p>
                                                    </Alert>
                                    }

                                    <div className="fv-row mb-8">
                                        <input
                                            className={"form-control bg-transparent " + (errors.usuario && touched.usuario ? "border-danger" : "")}
                                            name='usuario'
                                            type='text'
                                            placeholder='Usuario'
                                            value={values.usuario}
                                            autoComplete='username'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.usuario && touched.usuario && <p className="text-danger mt-2">{errors.usuario}</p>}
                                    </div>
                                    <div className="fv-row mb-3">
                                        <input
                                            className={"form-control bg-transparent " + (errors.password && touched.password ? "border-danger" : "")}
                                            name='password'
                                            type='password'
                                            placeholder='Password'
                                            value={values.password}
                                            autoComplete='current-password'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.password && touched.password && <p className="text-danger mt-2">{errors.password}</p>}
                                    </div>
                                    {/*<div className="d-flex flex-wrap gap-3 fs-base fw-semibold mb-8 justify-content-end">*/}
                                    {/*    <Link to={'/reset-password'} className="link-primary"> Cambiar contraseña </Link>*/}
                                    {/*</div>*/}
                                    <div className="d-grid mb-10">
                                        <button type="submit" disabled={isSubmitting} id="kt_sign_in_submit" className="btn btn-primary mt-3">
                                            <span className="indicator-label">Sign In</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <FooterLogin/>
                    </div>
                    <SideLogin/>
                </div>
            </div>
        </>
    );
}

export function FooterLogin(){
    return(
    <div className="d-flex flex-center flex-wrap px-5">
        <div className="d-flex fw-semibold fs-base">
            {/*Cambiar por Link o NavLink
                <button className="btn px-5 text-primary" target="_blank">Terms</button>
                <button className="btn px-5 text-primary" target="_blank">Plans</button>
                <button className="btn px-5 text-primary" target="_blank">Contact Us</button>
            */}
        </div>
    </div>
    );
}

export function SideLogin(){
    return(
    <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bg-primary order-1 order-lg-2">
        <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
           {/*} <button className="btn btn-icon mb-0 mb-lg-12">
                <img alt="Logo" src={logo} className="h-60px h-lg-75px" />
            </button>
            <img className="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20" src="assets/media/misc/auth-screens.png" alt="" />
            {/* Agregar textos
            <h1 className="d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7">Iniciar sesión</h1>
            <div className="d-none d-lg-block text-white fs-base text-center">
                <button className="btn opacity-75-hover text-warning fw-bold me-1"></button>
                <button className="btn opacity-75-hover text-warning fw-bold me-1"></button>
                <br /></div>*/}
        </div>
    </div>
    );
}
